<template>
  <div ref="lavContainer" :style="style"></div>
</template>

<script>
import lottie from "lottie-web";

export default {
  props: {
    height: Number,
    width: Number
  },

  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : "100%",
        height: this.height ? `${this.height}px` : "100%",
        overflow: "hidden",
        margin: "0 auto"
      },
      anim: undefined
    };
  },
  destroy() {
    this.anim.destroy();
    this.$destroy();
  },
  methods: {
    load(options) {
      if (this.anim) {
        this.anim.destroy();
      }
      this.anim = lottie.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: "svg",
        loop: options.loop !== false,
        autoplay: options.autoplay !== false,
        animationData: options.animationData,
        rendererSettings: options.rendererSettings
      });
      this.$emit("animCreated", this.anim);
    }
  }
};
</script>
